import { RpcImpl } from '../rpc/impls/rpc';
import { DefineRpcMethods, Rpc } from '../rpc/rpc';

export const SmartFilterProxy = Symbol('SmartFilterProxy');

// export enum SmartFilterSourcePageType {
//     SPR = 'spr',
//     WS = 'ws',
// }

/** 生成过滤时的页面信息 */
// export interface SmartFilterSourcePageInfo {
//     /** 页面全路径 */
//     fullPath: string;
//     /** 页面类型 */
//     type: SmartFilterSourcePageType;
// }

export interface SmartFilterResult {
    /** 过滤结果的 id, 用于标识过滤结果, 唯一标识 */
    filterId: string;
    /** 消息 id 用于和 agent 消息关联 */
    messageId: string;

    /** 生成过滤时的页面信息(过滤前) */
    // pageInfoBeforeFilter?: SmartFilterSourcePageInfo;

    /** 用户输入的文本 */
    userInputText: string;

    /** 专利列表 */
    patents: {
        patentId: string;
        pn: string;
        filterItem: string[];
        filterReason: string;
    }[];

    /** 选中的类型 */
    selected?: {
        type: string;
        count?: number;
    }[];
    /** 选中的专利 PN */
    selectedPatentPNs?: string[];
}

// 定义 Host 端 RPC 方法
type RpcSmartFilterHost = DefineRpcMethods<{
    /**
     * 获取当前页面信息
     */
    // getCurrentSmartFilterSourcePageInfo(): Promise<SmartFilterSourcePageInfo>;

    /**
    * 追加过滤项
    */
    appendSmartFilterResult(filter: SmartFilterResult): Promise<void>;
}>;

// 定义 Hiro 端 RPC 方法
type RpcSmartFilterHiro = DefineRpcMethods<{
    openSmartFilterResult(params: {
        agentJobId: string;
    }): void
}>;

export interface SmartFilterProxy {
    // eventProxy: EventEmitter<SmartFilterEvents>;
    rpcHost: Rpc<RpcSmartFilterHost>;
    rpcHiro: Rpc<RpcSmartFilterHiro>;
}

export function createSmartFilterProxy(): SmartFilterProxy {
    return {
        // eventProxy: new EventEmitterImpl<SmartFilterEvents>(),
        rpcHost: new RpcImpl<RpcSmartFilterHost>(),
        rpcHiro: new RpcImpl<RpcSmartFilterHiro>(),
    };
}
